import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Sigil } from "@/components/Sigil";
import { Breadcrumbs } from "@/components/Brand";
import { BRIEFING, BRIEFING_STEPS as STEPS, BRIEFING_LORE as LORE } from "@/lib/briefing";

export default function Briefing() {
  return (
    <div data-testid="briefing-page">
      <Breadcrumbs items={[["Suspect interviews", "/"], ["Briefing"]]} />
      <span className="caption mt-8">{BRIEFING.caption}</span>
      <h1 className="text-5xl font-black mt-2">{BRIEFING.title}</h1>
      <div className="grid grid-cols-12 gap-12 mt-10">
        <div className="col-span-12 xl:col-span-5">
          <p className="inset text-xl mb-8" data-testid="briefing-any-order"><strong>{BRIEFING.anyOrder}</strong> {BRIEFING.anyOrderRest}</p>
          <ol className="border-l-2 border-[#b1b4b6] ml-5 space-y-7" data-testid="briefing-steps">
            {STEPS.map(([t, d], i) => (
              <li key={t} className="relative pl-10 rise" style={{ animationDelay: `${i * 60}ms` }}>
                <span className="step-num absolute -left-[23px] top-0">{i + 1}</span>
                <h2 className="text-2xl font-black pt-1.5">{t}</h2>
                <p className="text-lg mt-1 leading-relaxed">{d}</p>
              </li>
            ))}
          </ol>
          <Link to="/" className="btn-spore mt-10" data-testid="briefing-to-hub-button">Go to suspect interviews <ChevronRight size={20} /></Link>
        </div>
        <div className="col-span-12 xl:col-span-7 panel p-10 relative overflow-hidden">
          <div className="absolute -right-10 -top-10 opacity-[0.07]"><Sigil size={320} color="#0b0c0c" /></div>
          <h2 className="text-3xl font-black">{BRIEFING.background}</h2>
          <div className="mt-6 space-y-7 relative" data-testid="briefing-lore">
            {LORE.map(([t, d]) => (
              <section key={t}>
                <h3 className="text-2xl font-black text-[#0033A1]">{t}</h3>
                <p className="text-[19px] leading-relaxed mt-2">{d}</p>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
